








































































import { mapActions, mapGetters, mapMutations } from "vuex";
import debounce from "lodash/debounce";

import { General, Home } from "@/utils/constants";
import { EXTERNAL_SEARCH_OPTIONS as searchOptions } from "@/utils/enumerate";

export default {
  name: "ConsultProcess",

  data() {
    return {
      Home,
      General,
      searchOptions,
      searchFilter: ""
    };
  },

  computed: {
    ...mapGetters({
      getSuggests: "getSuggests",
      getIsSearchSuite: "getIsSearchSuite",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),
    isSearchSuite: {
      get() {
        return this.getIsSearchSuite;
      },
      set(value: boolean) {
        this.setSearchSuite(value);
      }
    },
    getFields() {
      const list = this.getSuggests.map((suggest: string) => ({
        name: suggest.toLowerCase()
      }));
      return this.searchFilter.length
        ? [{ name: this.searchFilter }, ...list]
        : list;
    },
    getSearchPlaceholder() {
      return this.isMobile
        ? General.PLACEHOLDER.SEARCH_PROCESS_REDUCED
        : General.PLACEHOLDER.SEARCH_PROCESS;
    }
  },
  methods: {
    ...mapActions({
      getFieldsForSearch: "getFieldsForSearch",
      searchViprocProcess: "searchViprocProcess"
    }),
    ...mapMutations({
      setSuggests: "setSuggests",
      setSearchSuite: "setSearchSuite",
      setFilterList: "setFilterList"
    }),

    onSelectSuggestion(option: { name: string }) {
      if (option) {
        this.searchFilter = option.name;
        this.submitSearchProcess();
      }
    },

    setSearchField(value: string) {
      this.searchFilter = value;
      this.requestFields(value);
    },

    requestFields: debounce(async function(value: string) {
      const searchTerms = value.trim().split(" ");
      const lastTerm = searchTerms[searchTerms.length - 1];

      if (lastTerm) {
        await this.getFieldsForSearch({ filter: lastTerm });
      }
    }, 500),

    onFocusSearch() {
      window.addEventListener("keydown", this.handleEnterKey);
    },

    onBlurSearch() {
      window.removeEventListener("keydown", this.handleEnterKey);
    },

    handleEnterKey(event: KeyboardEvent) {
      if (event.key === "Enter" && this.searchFilter.trim() !== "") {
        this.submitSearchProcess();
        this.setSuggests({ suggests: [] });
      }
    },

    submitSearchProcess: debounce(async function(redirect = true) {
      this.setFilterList({
        search: this.searchFilter
      });
      if (this.isSearchSuite)
        redirect && this.$router.push(`/consultar-processo`);
      else this.searchViprocProcess(this.searchFilter);
    }, 200)
  }
};
